import {IGridData} from '../../ap-interface';
import IFertilizerOrganic = Data.BaseData.IFertilizerOrg;

export enum OrganicFertilizerGridActions {
  Active = 0,
  Inactive = 1
}

export interface IFertilizerOrganicGridData extends IGridData<IFertilizerOrganic> {
  Status: number;
  StatusClass: string;
  StatusDesc: string;
  CaOValue: any;
  KValue: any;
  MGValue: any;
  NValue: any;
  PValue: any;
  Efficiency: any;
  DMPercent: any;
  Liquid: any;
  Density: any;
  Unit: any;
  RealContentCaO: any;
}
